import React from 'react';
import { hooks } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';
import { HelpbotLink } from '../HelpbotLink';
const OrdersIsOrderCapturedNoBotMessage = () => {
    const t = hooks.useTranslator();
    const helpPage = '&help-page=article%3Ahow-do-i-cancel-an-order';
    const href = '/orders/to-capture?sort_field=created_at&sort_direction=DESC';
    const link1 = React.createElement(HelpbotLink, { href: `${href}${helpPage}` }, t('helpbot.explanations.orders.isOrderCapturedNoLink1'));
    const link2 = React.createElement(HelpbotLink, { href: href }, t('helpbot.explanations.orders.isOrderCapturedNoLink2'));
    return (React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.explanations.orders.isOrderCapturedNo', { link1, link2 })));
};
export default OrdersIsOrderCapturedNoBotMessage;
